<template>
  <div>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center" >
          <span class="label-contacto-paciente" v-if="contactosPaciente.length > 0">Por favor verifique con el paciente si su información es correcta, si no es correcta, por favor modifíquela.</span>
          <span class="label-contacto-paciente" v-if="contactosPaciente.length === 0">Este paciente no tiene información de contacto, por favor agregue uno para continuar.</span>
        </b-col>
      </b-row>

      <b-row class="mt-3" v-if="contactosPaciente.length > 0 && !loader">
        <b-col cols="6" :offset="4" class="d-flex" v-for="(contacto, index) in contactosPaciente" :key="index">
          <em class="add_tx" v-if="index===0" style="height: 24px; cursor: pointer; margin-right: 5px; margin-top: 4px;" @click="agregarContactoPaciente" v-b-tooltip.hover.topright.v-light
              title="Agregar nuevo contacto"></em>
          <em v-else style="height: 24px; min-width: 24px; margin-right: 5px; margin-top: 4px;"></em>
          <!-- Botón que dispara el popover -->
          <b-input-group class="mb-3 align-items-center">
            <b-button
                :id="'popover-medio-contacto-' + index"
                class="border-button"
                size="sm"
            >
              <b-icon
                  :icon="mapIcono(listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto).descripcion)"
                  class="mr-2"
              />
              <font-awesome-icon :icon="['fas', 'chevron-up']" :class="{ 'rotate-chevron': contacto.popoverAbierto }" />
            </b-button>

            <!-- Popover con las opciones -->
            <b-popover
                v-if="listaMediosContacto.length"
                :target="'popover-medio-contacto-' + index"
                triggers="click blur"
                placement="bottom"
                @shown="contacto.popoverAbierto = true"
                @hidden="contacto.popoverAbierto = false"
            >
              <div class="list-group list-group-flush">
              <span
                  v-for="tipo in listaMediosContacto"
                  :key="tipo.idMedioContacto"
                  class="list-item-contact p-1"
                  @click="seleccionarTipo(tipo , index)"
              >
                <b-icon :icon="mapIcono(tipo.descripcion)" class="mr-2" style="color: #AFB7BE"/>
                {{ tipo.descripcion }}
              </span>
              </div>
            </b-popover>

            <!-- Input dinámico -->
            <b-form-input
                v-model="contacto.contacto"
                :type="getTipoInput(listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto))"
                :placeholder="getPlaceholder(listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto))"
                :state="validarContacto(contacto) && contacto.contacto.trim() !== ''"
                class="form-control-sm border-input"
                @keydown="bloquearLetrasSiEsTel($event , contacto)"
            ></b-form-input>
            <b-form-invalid-feedback v-if="contacto.contacto.trim() !== '' && !validarContacto(contacto)">
              {{ esCorreo(contacto.idMedioContacto)
                ? 'Correo inválido'
                : 'Debe contener 10 dígitos numéricos' }}
            </b-form-invalid-feedback>

          </b-input-group>

          <!-- Switch -->
          <b-form-checkbox
              v-model="contacto.preferente"
              switch
              size="lg"
              v-b-tooltip.top.hover.v-light
              :title="'Marcar como preferente'"
          ></b-form-checkbox>

          <em
              class="trash_svg"
              style="cursor: pointer; position: relative; left: -50px; top: -8px; max-width: 24px; max-height: 47px"
              v-b-tooltip.hover.topright.v-light
              title="Inactivar"
              @click="eliminarContacto(contacto, index)">
          </em>
        </b-col>
      </b-row>

      <b-row class="mt-3" v-else-if="contactosPaciente.length === 0 && !loader">
        <b-col cols="12" class="d-flex justify-content-center">
          <em class="add_tx" style="height: 24px; cursor: pointer; margin-right: 5px; margin-top: 4px;" @click="agregarContactoPaciente" v-b-tooltip.hover.topright.v-light
              title="Agregar nuevo contacto"></em>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="12" class="justify-content-center d-flex">
          <b-button variant="outline-info" class="rounded-pill" size="sm" :disabled="!contactosValidos || contactosPaciente.length === 0 || loader || loaderGuardar" @click="guardarDatosPaciente()">Guardar y continuar <b-spinner small v-if="loaderGuardar"></b-spinner></b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: "DatosContactoPopover",
  props: {
    idPaciente: Number,
    idPacientePadre: Number,
  },
  data: () => ({
    listaMediosContacto: [],
    contactosPaciente: [],
    contactosOriginales: [],
    loader: false,
    loaderGuardar: false,
  }),
  async created() {
    this.loader = true;
    await this.catalogoMetodosContacto();
    this.obtenerDatosContactoPaciente();
  },
  computed: {
    contactosValidos() {
      return this.contactosPaciente.every(contacto => {
        const esValido = this.validarContacto(contacto);
        const noVacio = contacto.contacto && contacto.contacto.trim() !== '';
        return esValido && noVacio;
      });
    }
  },
  watch: {
    contactosPaciente: {
      deep: true,
      handler(nuevos) {
        nuevos.forEach((contacto, index) => {
          const original = this.contactosOriginales[index];
          if (!original) return;

          const haCambiado =
              contacto.idMedioContacto !== original.idMedioContacto ||
              contacto.contacto !== original.contacto ||
              contacto.preferente !== original.preferente;

          contacto.editar = haCambiado;
        });
      }
    }
  },
  methods: {

    nuevoContactoVacio() {
      return {
        idMedioContactoPaciente: null, // Para nuevos contactos
        idMedioContacto: 2,
        contacto: '',
        preferente: false,
        popoverAbierto: false,
        editar: true
      };
    },

    agregarContactoPaciente() {
      this.contactosPaciente.push(this.nuevoContactoVacio());
    },

    async catalogoMetodosContacto() {
      await this.$http.get(this.$api + "catalogos/listaMediosContacto").then((res) => {
        this.listaMediosContacto = res.data.data
      })
    },

    obtenerDatosContactoPaciente() {
      this.$http.post(this.$api + "paciente/obtenerDatosContactoPaciente", {
        idPaciente: this.idPaciente,
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          // Mapeamos los datos del API usando la lista de medios de contacto
          this.contactosPaciente = res.data.data.map(contactoApi => {
            return {
              idMedioContactoPaciente: contactoApi.idMedioContactoPaciente,
              idMedioContacto: contactoApi.idMedioContacto,
              contacto: contactoApi.contacto,
              preferente: contactoApi.preferente,
              popoverAbierto: false,
              editar: contactoApi.editar
            };
          });

          this.contactosOriginales = this.contactosPaciente.map(c => ({ ...c }));
        } else {
          // Si no hay contactos, agregamos uno vacío por defecto
          this.contactosPaciente = [this.nuevoContactoVacio()];
        }
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.loader = false;
      })
    },

    seleccionarTipo(tipo, index) {
      this.contactosPaciente[index].idMedioContacto = tipo.idMedioContacto;
      this.contactosPaciente[index].contacto = '';

      this.contactosPaciente[index].popoverAbierto = false;

    },

    mapIcono(desc) {
      const d = desc.toUpperCase()
      if (d.includes('CELULAR')) return 'telephone-fill'
      if (d.includes('TRABAJO')) return 'briefcase-fill'
      if (d.includes('CASA')) return 'house-fill'
      if (d.includes('CORREO')) return 'at'
      return 'question-circle'
    },

    getTipoInput(tipo) {
      return tipo.descripcion.includes('CORREO') ? 'email' : 'tel';
    },

    getPlaceholder(tipo) {
      return tipo.descripcion.includes('CORREO')
          ? 'correo@ejemplo.com'
          : '123 456 7890';
    },

    eliminarContacto(contacto, index) {
      if (contacto.idMedioContactoPaciente == null) {
        this.contactosPaciente.splice(index, 1);
      }else{
        this.inactivarContacto(contacto.idMedioContactoPaciente);
      }
    },

    guardarDatosPaciente() {
      // Validación 1: ningun contacto debe de ir vacio
      if (this.contactosPaciente.find(t => t.contacto.trim() === "")) {
        this.$swal.fire({
          icon: "warning",
          title: "Contacto",
          html: "Existe un contacto no valido",
        })
        return;
      }

      // Validación 2: cada idMedioContacto debe tener al menos un preferente
      const medios = [...new Set(this.contactosPaciente.map(c => c))];

      for (const medio of medios) {
        const relacionados = this.contactosPaciente.filter(c => c.idMedioContacto === medio.idMedioContacto);
        const algunoPreferente = relacionados.some(c => c.preferente === true);

        if (!algunoPreferente) {
          this.$swal.fire({
            icon: "warning",
            title: "Falta preferente",
            html: `El medio de contacto <b>${this.listaMediosContacto.find(t => t.idMedioContacto === medio.idMedioContacto).descripcion}</b> no tiene ningún contacto marcado como preferente.`,
          });
          return;
        }
      }

      // Validación 3: no deben repetirse combinaciones idMedioContacto + contacto (normalizado)
      const duplicados = new Set();
      for (const c of this.contactosPaciente) {
        const contactoNormalizado = this.normalizarContacto(c.contacto);
        const key = `${c.idMedioContacto}-${contactoNormalizado}`;  // Usa el valor normalizado

        if (duplicados.has(key)) {
          const descripcion = this.listaMediosContacto.find(t => t.idMedioContacto === c.idMedioContacto)?.descripcion || 'Medio';
          this.$swal.fire({
            icon: "warning",
            title: "Contacto duplicado",
            html: `Ya existe otro contacto con el mismo medio <b>${descripcion}</b> y el mismo valor <b>${c.contacto}</b>.`,
          });
          return;
        }
        duplicados.add(key);
      }

      // Validación 4: solo un preferente por idMedioContacto
      for (const medioId of medios) {
        const relacionados = this.contactosPaciente.filter(c => c.idMedioContacto === medioId.idMedioContacto && c.preferente === true);
        if (relacionados.length > 1) {
          const descripcion = this.listaMediosContacto.find(t => t.idMedioContacto === medioId.idMedioContacto).descripcion;
          this.$swal.fire({
            icon: "warning",
            title: "Demasiados preferentes",
            html: `El medio de contacto <b>${descripcion}</b> tiene más de un contacto marcado como preferente.`,
          });
          return;
        }
      }

      if (this.contactosPaciente.some(c => c.editar === true)) {
        this.loaderGuardar = true;
        const params = {
          idPaciente: this.idPacientePadre !== null ? this.idPacientePadre : this.idPaciente,
          contactosAlta: this.contactosPaciente.filter(item => item.editar === true),
        }
        this.$http.post(this.$api + "paciente/guardarDatosContactoPaciente", params).then((res) => {
          if (res.status === 200) {
            this.$emit('datosContactoPaciente', this.contactosPaciente);
          }else{
            this.$swal.fire({
              icon: "error",
              title: "Hubo un error",
              text: "No se pudo guardar el contacto del paciente",
            });
          }
        }).catch((err) => {
          console.error(err);
          this.$swal.fire({
            icon: "error",
            title: "Hubo un error en el servicio",
            text: "No se pudo guardar el contacto del paciente",
          });
        }).finally(() => {
          this.loaderGuardar = false;
        });
      }else{
        this.$emit('datosContactoPaciente', this.contactosPaciente);
      }

    },

    inactivarContacto(contacto) {
      this.$http.post(this.$api + "paciente/inactivarContactoPaciente", {idMedioContactoPaciente : contacto})
      .then((res) => {
        if (res.data.data) {
          this.obtenerDatosContactoPaciente();
        }else{
          this.$swal.fire({
            icon: "error",
            title: "Hubo un error",
            text: "No se pudo inactivar el registro",
          });
        }
      })
    },

    esTelefono(idMedioContacto) {
      return [1, 2, 4].includes(idMedioContacto); // Teléfono Casa, Celular, Trabajo
    },
    esCorreo(idMedioContacto) {
      return idMedioContacto === 3;
    },
    validarContacto(contacto) {
      if (this.esTelefono(contacto.idMedioContacto)) {
        const numeroLimpio = contacto.contacto.replace(/\s/g, '');
        return /^\d{10}$/.test(numeroLimpio);
      }
      if (this.esCorreo(contacto.idMedioContacto)) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contacto.contacto);
      }
      return false;
    },

    bloquearLetrasSiEsTel(event , contacto) {
      const tipoInput = this.getTipoInput(
          this.listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto)
      );

      if (tipoInput === 'tel') {
        // Permitir solo teclas numéricas, Backspace, Delete, Tab, Flechas, etc.
        const teclasPermitidas = [
          32,
          8,  // Backspace
          9,  // Tab
          13, // Enter
          46, // Delete
          37, 38, 39, 40 // Flechas
        ];

        if (teclasPermitidas.includes(event.keyCode) ||
            (event.keyCode >= 48 && event.keyCode <= 57) || // Números
            (event.keyCode >= 96 && event.keyCode <= 105)    // Numpad
        ) {
          return; // Permitir la tecla
        }

        event.preventDefault(); // Bloquear cualquier otra tecla
      }
    },

    normalizarContacto(contacto) {
      if (!contacto) return '';
      if (contacto.includes('@')) {
        return contacto.trim().toLowerCase();
      }
      return contacto.replace(/\D/g, '');
    },
  }
}
</script>
<style scoped>
.border-button{
  border: 1px solid #D0D0D0;
  border-radius: 8px 0px 0px 8px;
  background-color: #fff;
  color: #AFB7BE;
}

.border-button:active , .border-input:hover{
  background-color: #fff !important;
}

.border-input{
  border-radius: 0px 8px 8px 0px;
}

.list-item-contact:hover{
  background-color: #E4F2FF !important;
  border-radius: 20px;
  cursor: pointer;
}

.rotate-chevron {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.label-contacto-paciente{
  color: #FEA269;
  font-size: 11px;
}

</style>
